export const ROUTE_PATH = '/gift-certificates';

export const FEATURE_NAME = 'giftCertificatesPage';
